// frontend/src/i18n.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import frTranslation from "./locales/fr/translation.json";
import esTranslation from "./locales/es/translation.json";
import enTranslation from "./locales/en/translation.json";
import deTranslation from "./locales/de/translation.json";
import itTranslation from "./locales/it/translation.json";
import ptTranslation from "./locales/pt/translation.json";

// Lecture sécurisée du localStorage (bloqué en navigation privée iOS / PWA sandboxé)
function safeGetLocalStorage(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch (_e) {
    return null;
  }
}

// Langues supportées
const supported = ["fr", "es", "en", "de", "it", "pt"];

// Détection initiale synchrone pour éviter le flash d'une mauvaise langue
const getInitialLang = (): string => {
  const stored = safeGetLocalStorage("i18nextLng");
  if (stored && supported.includes(stored.split("-")[0])) return stored;
  
  const browserLang = navigator.language?.split("-")[0] ?? "en";
  return supported.includes(browserLang) ? browserLang : "en";
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getInitialLang(), // ✅ Force la langue dès le départ
    resources: {
      en: { translation: enTranslation }, // ✅ English first
      fr: { translation: frTranslation },
      es: { translation: esTranslation },
      de: { translation: deTranslation },
      it: { translation: itTranslation },
      pt: { translation: ptTranslation },
    },
    supportedLngs: supported,
    nonExplicitSupportedLngs: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
